import "./comment-box.scss";
import { textAreaResize } from "../../../client/textarea-resize";

(function (){
    const loadMoreButton = document.querySelector('.comment-box__load-more-button');
    const listBox = document.querySelector('.comment-box__list');

    if (!listBox) {
        return;
    }

    Array.from(document.querySelectorAll('.comment-box__form')).forEach(initForm);

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', event => {
            const articleID = loadMoreButton.getAttribute('data-article-id');
            const skip = document.querySelectorAll('.comment-box__item').length;
            fetch(`/api/comment/?article_id=${articleID}&skip=${skip}`).then(response => response.json()).then(response => {
                if (response.success) {
                    listBox.insertAdjacentHTML("beforeend", response.html);
                    const total = response.count_comments - listBox.children.length;

                    if (total > 0) {
                        loadMoreButton.querySelector('.js-total').innerHTML = total > 30 ? 30 : total;
                    } else {
                        loadMoreButton.classList.add('hidden');
                    }
                }
            });
        });
    }

    listBox.addEventListener('click', event => {
        const toggleButton = event.target.closest('.comment-box__item-toggle-form');
        if (toggleButton) {
            toggleButton.nextElementSibling.classList.toggle("_show");
        }
    })

})();

function initForm(form) {
    attachEventForm(form);
    textAreaResize(form.querySelector('.comment-box__input'));
}

function attachEventForm(form) {
    if (form) {
        form.addEventListener('submit', event => {
            event.preventDefault();
            if (validateForm(form)) {
                sendMessage(form);
            }
        });
    }
}


function validateForm(form) {
    const data = new FormData(form);

    return ![data.get('article_id'), data.get('message').length > 1].includes(false)
}


function sendMessage(form) {
    return fetch('/api/comment/', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        body: new FormData(form)
    }).then(function (response) {
        return response.json();
    }).then(response => {
        renderComment(form, response)
        form.querySelector("[name='message']").value = "";
    });
}


function renderComment(form, response) {
    let parentElement = form.closest(".comment-box__item");
    let formElement;

    if (parentElement) {
        parentElement.querySelector('.comment-box__item-inner-form').classList.remove('_show');
        parentElement.insertAdjacentHTML("afterend", response.html);

        formElement = parentElement.nextElementSibling.querySelector('.comment-box__form');

    } else {
        parentElement = form.closest('.comment-box').querySelector('.comment-box__list');
        parentElement.insertAdjacentHTML("beforeend", response.html);

        formElement = parentElement.children[
            parentElement.children.length -1
        ].querySelector('.comment-box__form');
    }

    if (formElement) {
        initForm(formElement);
    }
}

